<template>
  <div class="box">
    <p class="heading is-size-4">Full Access</p>
    <p class="is-size-1">
      $4<sup class="is-size-5">.99</sup>
      <span class="is-size-5">/ month</span>
    </p>
    <p class="is-size-5">per seat</p>
    <br v-if="!hideDetails" />
    <div v-if="!hideDetails" class="columns is-centered is-mobile">
      <div class="column is-8 has-text-left">
        <p>
          <b-icon
            class="included"
            pack="fas"
            icon="check"
            type="is-success"
          ></b-icon>
          All languages
        </p>
        <p>
          <b-icon
            class="included"
            pack="fas"
            icon="check"
            type="is-success"
          ></b-icon>
          All books
        </p>
        <p>
          <b-icon
            class="included"
            pack="fas"
            icon="check"
            type="is-success"
          ></b-icon>
          Unlimited recordings
        </p>
        <p>
          <b-icon
            class="included"
            pack="fas"
            icon="check"
            type="is-success"
          ></b-icon>
          Unlimited dictations
        </p>
        <p>
          <b-icon
            class="included"
            pack="fas"
            icon="check"
            type="is-success"
          ></b-icon>
          Full progress reports
        </p>
      </div>
    </div>
    <br />
    <p class="has-text-weight-bold has-text-info">
      Unlimited access to all paragraphs
    </p>
    <br />
    <div>
      <b-button
        tag="router-link"
        to="/licences/purchase"
        type="is-info"
        size="is-medium"
        expanded
      >
        <strong>Buy</strong>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["hideDetails"]
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline;

  &.included {
    padding-right: 10px;
  }
}
</style>
